import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Error } from "@ui/error/Error";
import Panel from "@ui/panel/Panel";
import { useState } from "react";
import { GD } from "src/GD";
import { FormParser } from "../FormParser";

export const AcquirerEditor = () => {
	useLocale();
	//!TODO:!!!!;
	const editorRequestData = GD.S_ACQUIRER_EDITOR.use();
	const [busySave, _setBusySave] = useState<boolean>();
	const [busyLoad, _setBusyLoad] = useState<boolean>();
	const [_saveError, _setSaveError] = useState<IError>();
	const [acquirer, _setAcquirer] = useState<IAcquirer>();
	const [acquirerError, _setAcquirerError] = useState<IError>();

	if (!editorRequestData) return null;

	const closePopup = () => {
		GD.S_ACQUIRER_EDITOR.invoke(null);
	};

	const onEditSuccess = () => {
		GD.S_ACQUIRERS_CHANGE.invoke({});
		closePopup();
	};

	return (
		<Panel
			sx={{
				width: "90vw",
				maxWidth: "600px",
				height: "80vh",
				padding: "0",
			}}
			onClose={() => closePopup()}
			label={acquirer && acquirer.id > 0 ? msg("editAcquirer") : msg("addAcquirer")}
			decorator="absolute"
			busy={busyLoad || busySave}>
			<Error error={acquirerError} />

			<FormParser
				key="acquirerEditor"
				onSubmit={async data => {
					// submit
					return await GD.REQ_API.request({
						method: "acquirers/add",
						data: data,
					});
				}}
				onRequest={async () => {
					return await GD.REQ_API.request({
						method: "acquirers/req",
						data: {
							id: editorRequestData.acquirerID,
						},
					});
				}}
				onComplete={onEditSuccess}
			/>
		</Panel>
	);
};
